"use client";

import React from "react";
import { Navbar } from "@/components/Navbar";
import { VehiclesList } from "@/components/vehiculos/VehiclesList";
import { Footer } from "@/components/Footer";

export default function BrandPage({ params }) {
  // En client component, params viene directamente
  const resolvedParams = params;
  
  // Mapeo estático de marcas (más rápido y confiable)
  const brandMapping = {
    'jac': 'JAC Motors',
    'jac-motors': 'JAC Motors',
    'kia': 'Kia',
    'ford': 'Ford',
    'geely': 'Geely',
    'lincoln': 'Lincoln',
    'mazda': 'Mazda',
    'shineray': 'Shineray',
    'farizon': 'Farizon',
    'forland': 'Forland',
    'swm': 'SWM'
  };
  
  const brandName = brandMapping[resolvedParams.brand.toLowerCase()] || 
                   resolvedParams.brand.charAt(0).toUpperCase() + resolvedParams.brand.slice(1).toLowerCase();
  
  return (
    <div>
      <Navbar />
      <VehiclesList 
        selectedBrandProp={brandName}
        showHeader={true}
        title={`Vehículos ${brandName}`}
        subtitle={`Descubre nuestra selección completa de vehículos ${brandName}, diseñados para satisfacer todas tus necesidades.`}
      />
      <Footer />
    </div>
  );
} 